import PropTypes from 'prop-types';
import { useAnalytics } from 'hooks/useAnalytics';
import { InView } from 'react-intersection-observer';
import { ButtonSmall } from 'elements/Forms';

const InPostCta = ({ href, icon, heading, text, button }) => {
  const { track } = useAnalytics();

  return (
    <InView
      as="span"
      onChange={(inView) => {
        if (inView) {
          track('In Post CTA Viewed', {
            heading,
            text,
            button,
          });
        }
      }}
      triggerOnce
      className="not-prose"
    >
      <a
        onClick={async (e) => {
          e.preventDefault();
          const newLocation = e.currentTarget.href;
          await track('In Post CTA Clicked', {
            heading,
            text,
            button,
          });
          window.location.assign(newLocation);
        }}
        href={href}
      >
        <span className="flex flex-col items-center justify-between gap-6 rounded-2xl bg-blue-02 p-10 shadow-md sm:flex-row">
          <span className="h-16 w-16 flex-shrink-0 rounded-2xl bg-blue-06 p-2 ">
            <img
              src={`/blog/media/icons/${icon}.svg`}
              alt={icon}
              width="48"
              height="48"
              className="h-12 w-12"
              style={{
                filter: 'invert(100%)',
              }}
            />
          </span>
          <span className="flex-grow text-center sm:text-left">
            <span className="block text-2xl font-bold tracking-tight text-grey-10 sm:text-3xl">
              {heading}
            </span>
            <span className="block text-grey-06">{text}</span>
          </span>
          <span className="flex-shrink-0">
            <ButtonSmall>{button}</ButtonSmall>
          </span>
        </span>
      </a>
    </InView>
  );
};

InPostCta.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
};

export default InPostCta;
